<template>
  <div>
    <div v-if="src" class="row__image" @click.stop="modalIsVisible = true">
      <img class="image__elem" :src="src" />
    </div>
    <div v-else class="block__warning">
      Нет фото
    </div>
    <FullsizeImageModal
      :show="modalIsVisible"
      :image-src="src"
      @close="modalIsVisible = false"
    />
  </div>
</template>

<script>
import FullsizeImageModal from '@/_shared/components/modals/FullsizeImageModal';
export default {
  components: {
    FullsizeImageModal,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    subfolder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalIsVisible: false,
    };
  },
}
</script>

<style scoped>
.row__image {
  width: 100px;
  height: 100px;
  display: inline-flex;
  justify-content: center;
}

.row__image:hover,
.row__image:focus {
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}
.block__warning {
  margin: 0 auto;
  height: 100px;
  width: 100px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: rgb(167, 167, 167);
}
</style>



// WEBPACK FOOTER //
// src/_shared/features/table/ImageRow.vue